// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/pictures/main auth.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthOnboarding_container__PwsPZ {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-height: 100vh;
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .AuthOnboarding_container__PwsPZ {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding-bottom: 5rem;
  }
}

.AuthOnboarding_content__D8vD4 {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 40%;
  padding: 8rem 5rem;
}
@media only screen and (max-width: 50em) {
  .AuthOnboarding_content__D8vD4 {
    background-image: none;
    align-items: center;
  }
}

.AuthOnboarding_fashIcon__qeRPF {
  width: 12rem;
  cursor: pointer;
}
@media only screen and (max-width: 50em) {
  .AuthOnboarding_fashIcon__qeRPF {
    margin: 0;
  }
}

.AuthOnboarding_welcome__wJhln {
  padding: 3rem;
  background-color: rgba(255, 255, 255, 0.65);
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .AuthOnboarding_welcome__wJhln {
    width: -moz-fit-content;
    width: fit-content;
    margin: 2rem;
  }
}

.AuthOnboarding_children__YB6eQ {
  width: 100%;
  height: 100%;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.2rem 4rem;
}
@media only screen and (max-width: 50em) {
  .AuthOnboarding_children__YB6eQ {
    width: 60rem;
    border-radius: 1rem;
    padding: 3rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .AuthOnboarding_children__YB6eQ {
    width: 80%;
  }
}
@media only screen and (max-width: 31.25em) {
  .AuthOnboarding_children__YB6eQ {
    width: 95%;
  }
}

.AuthOnboarding_form__QqtB6 {
  width: 60%;
}
@media only screen and (max-width: 75em) {
  .AuthOnboarding_form__QqtB6 {
    width: 80%;
  }
}
@media only screen and (max-width: 56.25em) {
  .AuthOnboarding_form__QqtB6 {
    width: 90%;
  }
}
@media only screen and (max-width: 50em) {
  .AuthOnboarding_form__QqtB6 {
    width: 80%;
  }
}
@media only screen and (max-width: 37.5em) {
  .AuthOnboarding_form__QqtB6 {
    width: 100%;
  }
}

.AuthOnboarding_account__desc__WxsE5 {
  font-size: var(--default-font-small);
  width: 38rem;
  text-align: center;
  margin-bottom: 3rem;
}
.AuthOnboarding_account__desc__WxsE5 span {
  font-weight: 700;
  color: var(--color-fash-primary-2);
}

.AuthOnboarding_clickable__hfOqN {
  color: var(--color-fash-primary-2);
  cursor: pointer;
}
.AuthOnboarding_clickable__hfOqN:hover {
  font-weight: 700;
}

.AuthOnboarding_goBack__OC\\+xM {
  display: flex;
  align-items: center;
  font-size: var(--default-font-subtitle);
  cursor: pointer;
  margin: 2rem 0;
  gap: 1rem;
}
.AuthOnboarding_goBack__OC\\+xM:hover {
  color: var(--color-fash-primary-2);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Auth/AuthOnboarding.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,gDAAA;EACA,iBAAA;EACA,WAAA;AADJ;AAGI;EANJ;IAOQ,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,yDAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;IACA,oBAAA;EAAN;AACF;;AAGA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;AAEI;EAZJ;IAaQ,sBAAA;IACA,mBAAA;EACN;AACF;;AAEA;EACI,YAAA;EACA,eAAA;AACJ;AACI;EAJJ;IAKQ,SAAA;EAEN;AACF;;AACA;EACI,aAAA;EACA,2CAAA;EACA,WAAA;AAEJ;AAAI;EALJ;IAMQ,uBAAA;IAAA,kBAAA;IACA,YAAA;EAGN;AACF;;AAAA;EACI,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAGJ;AADI;EAVJ;IAWQ,YAAA;IACA,mBAAA;IACA,aAAA;EAIN;AACF;AAFI;EAhBJ;IAiBQ,UAAA;EAKN;AACF;AAHI;EApBJ;IAqBQ,UAAA;EAMN;AACF;;AADA;EACI,UAAA;AAIJ;AAFI;EAHJ;IAIQ,UAAA;EAKN;AACF;AAHI;EAPJ;IAQQ,UAAA;EAMN;AACF;AAJI;EAXJ;IAYQ,UAAA;EAON;AACF;AALI;EAfJ;IAgBQ,WAAA;EAQN;AACF;;AAHI;EACI,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAMR;AAJQ;EACI,gBAAA;EACA,kCAAA;AAMZ;;AADA;EACI,kCAAA;EACA,eAAA;AAIJ;AAFI;EACI,gBAAA;AAIR;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;AAGJ;AADI;EACI,kCAAA;AAGR","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    min-height: 100vh;\n    width: 100%;\n\n    @media only screen and (max-width: $bp-800) {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        background-image: url('../../img/pictures/main auth.jpg');\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center;\n        padding-bottom: 5rem;\n    }\n}\n\n.content {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n    background-image: url('../../img/pictures/main auth.jpg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 40%;\n    padding: 8rem 5rem;\n\n    @media only screen and (max-width: $bp-800) {\n        background-image: none;\n        align-items: center;\n    }\n}\n\n.fashIcon {\n    width: 12rem;\n    cursor: pointer;\n\n    @media only screen and (max-width: $bp-800) {\n        margin: 0;\n    }\n}\n\n.welcome {\n    padding: 3rem;\n    background-color: rgba(255, 255, 255, 0.65);\n    width: 100%;\n\n    @media only screen and (max-width: $bp-800) {\n        width: fit-content;\n        margin: 2rem;\n    }\n}\n\n.children {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-white);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1.2rem 4rem;\n\n    @media only screen and (max-width: $bp-800) {\n        width: 60rem;\n        border-radius: 1rem;\n        padding: 3rem;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        width: 80%;\n    }\n\n    @media only screen and (max-width: $bp-500) {\n        width: 95%;\n    }\n\n\n}\n\n.form {\n    width: 60%;\n\n    @media only screen and (max-width: $bp-1200) {\n        width: 80%;\n    }\n\n    @media only screen and (max-width: $bp-900) {\n        width: 90%;\n    }\n\n    @media only screen and (max-width: $bp-800) {\n        width: 80%;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        width: 100%;\n    }\n}\n\n\n.account {\n    &__desc {\n        font-size: var(--default-font-small);\n        width: 38rem;\n        text-align: center;\n        margin-bottom: 3rem;\n\n        span {\n            font-weight: 700;\n            color: var(--color-fash-primary-2);\n        }\n    }\n}\n\n.clickable {\n    color: var(--color-fash-primary-2);\n    cursor: pointer;\n\n    &:hover {\n        font-weight: 700;\n    }\n}\n\n.goBack {\n    display: flex;\n    align-items: center;\n    font-size: var(--default-font-subtitle);\n    cursor: pointer;\n    margin: 2rem 0;\n    gap: 1rem;\n\n    &:hover {\n        color: var(--color-fash-primary-2);\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AuthOnboarding_container__PwsPZ`,
	"content": `AuthOnboarding_content__D8vD4`,
	"fashIcon": `AuthOnboarding_fashIcon__qeRPF`,
	"welcome": `AuthOnboarding_welcome__wJhln`,
	"children": `AuthOnboarding_children__YB6eQ`,
	"form": `AuthOnboarding_form__QqtB6`,
	"account__desc": `AuthOnboarding_account__desc__WxsE5`,
	"clickable": `AuthOnboarding_clickable__hfOqN`,
	"goBack": `AuthOnboarding_goBack__OC+xM`
};
export default ___CSS_LOADER_EXPORT___;
